import React, { createContext } from 'react';

export interface ISislogThemeContext {
}

export const SislogThemeContextDefaultValue: ISislogThemeContext = {
}

const SislogThemeContext = createContext<ISislogThemeContext>(SislogThemeContextDefaultValue);

const SislogThemeProvider: React.FC = ({
  children
}) => {

  return (
    <SislogThemeContext.Provider value={SislogThemeContextDefaultValue}>
      {children}
    </SislogThemeContext.Provider>
  );
}

export { SislogThemeProvider };
export default SislogThemeContext;